<template>
  <div
    class="opple-device-card"
    :class="{ offLine: cardData.isOffLine, warnShadow: cardData.isflicker }"
    @click="handlerCardClick"
  >
    <div
      v-if="selectType !== 0"
      class="opple-device-card_checkbox"
    >
      <el-checkbox
        v-if="selectType === 1"
        v-model="cardData.checked"
        @change="onCheckBoxChange"
      />
      <el-radio
        v-if="selectType === 2"
        v-model="cardData.checked"
        label=""
        @input="onCheckBoxChange"
      />
    </div>
    <div
      class="opple-device-card_preview"
    >
      <div
        class="opple-device-card_preview_img"
      >
        <img
          v-if="cardData.previewSrc"
          :src="cardData.previewSrc"
        >
      </div>
      <div
        class="opple-device-card_preview_deviceName"
        :title="cardData.deviceName"
      >
        {{ cardData.deviceName }}
      </div>
      <descList
        v-if="!cardData.isOffLine"
        :data="data"
      />
    </div>
    <control
      :data="cardData"
      @flash="onFlash"
    />
  </div>
</template>

<script>
import { getImgUrlState } from "@/utils/utils";
import { DESC_FULL_CONFIG, DESC_HALF_CONFIG } from './config';
import descList from './descList.vue';
import control from './control.vue';
import {getdeviceImageStatus } from '@/utils/utils'

export default {
  name: 'OppleDeviceCard',
  components: {
    descList,
    control
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selectType: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      cardData: {},
      isFlash: false
    };
  },

  computed: {

  },

  watch: {
    data() {
      this.initCard();
    }
  },

  mounted() {
    this.initCard();
  },

  methods: {
    getdeviceImageStatus,
    handlerCardClick(e) {
      console.log('e.target.nodeName.className', e.target.className);
      
      if (
        e.target && 
        e.target.className && 
        (
          e.target.className.includes('el-checkbox') || 
          e.target.className.includes('el-radio')
        )
      ) {
        return;
      }
      
      this.$emit('select', this.data, !this.data.checked)
    },
  
    initCard() {
      const { data, $store, getClassSkuImage } = this;
      const dataProxy = {
        ...data,
      }

      if (typeof dataProxy.StatusInfo === 'string') {
        dataProxy.StatusInfo = JSON.parse(dataProxy.StatusInfo);
      }

      const cardData = {
        ...dataProxy,
        // 头图
        previewSrc: 
          $store.state.isLocalServer ? getClassSkuImage(dataProxy, 'on') : getImgUrlState(dataProxy, 'on'),
        // 设备名字
        deviceName: this.getDeviceName(),
        isOffLine: this.getdeviceImageStatus(dataProxy, '0X0100', '0'),
        isflicker: false,
        // descList: this.getDescList() || []
        // desc: 
      }
      console.log('cardData!!!!', cardData);
      
      this.cardData = cardData;
    },

    getDeviceName() {
      const { data } = this;
      const { ChildId, DeviceName, ChildName } = data;

      if (ChildId === 65535) return DeviceName;

      return `${ChildName}-${DeviceName}`
    },

    onFlash(boolean) {
      console.log('onFlashonFlash');

      this.isFlash = boolean;
    },

    onCheckBoxChange(value) {
      console.log('value', value);
      
      this.$emit('select', this.data, value)
    },

    // getdeviceImageStatus(msg, type, value) {
    //   var result = null;
  
    //   if (msg != null && msg.StatusInfo != null) {
    //     msg.StatusInfo.forEach((model) => {
    //       if (
    //         model.IsTop &&
    //         model.StatusType.toUpperCase().indexOf(type.toUpperCase()) >= 0 &&
    //         (msg.ChildId != 65535 ? model.ChannelId == msg.ChildId : true) &&
    //         (msg.ChildId == 65535
    //           ? msg.ClassSku.toUpperCase() != "0X001C3003"
    //           : true)&& msg.ChildCategoryType !== 4
    //       ) {
    //         if (model["Value"] == value || model["Value1"] == value) {
    //           result = true;
    //         } else {
    //           result = false;
    //         }
    //       }
    //     });
    //   }
    //   return result;
    // },
  },
};
</script>

<style lang="scss">
.opple-device-card {
  position: relative;
  box-sizing: border-box;
  width: 226px;
  height: 217px;
  background: #fefefe;
  border: 1px solid #dde2ea;
  border-radius: 3px;

  &_checkbox {
    position: absolute;
    right: 10px;
    top: 10px;

    .el-checkbox__inner {
      border: 1px solid #fff;
    }
  }

  &_preview {
    width: 100%;
    height: 125px;
    padding-top: 15px;
    background: #d7e6fa;
   
    &_img {
      display: flex;
      justify-content: center;
      height: 43px;

      img {
        height: 100%;
        text-align: center;
      }
    }

    &_deviceName {
      font-size: 12px;
      line-height: 28px;
      color: #2481ea;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    &_desc {
      li {
        display: flex;
        align-items: center;
        justify-content: center;

        
      }
      &_text {
          min-width: 50px;
          text-align: center;
        }
    }

    &_icon {
      height: 14px;
      img {
          height: 100%;
        }
    }
  }

  &.offLine {
    .opple-device-card_preview {
      background: #e8e2e2; // rgb(227, 230, 236);
      opacity: 0.65;
      filter: grayscale(100%);
    }
    
  }
}
</style>